import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import AncillarySalePage from './AncillarySalePage';
import RenewalSalePage from './RenewalSalePage';
import { getSalePageConfig, RECEPTIONIST_SALE_PAGES } from './salePageConfig';

/** Resolves the sale page config from the current URL and renders the shared form. */
export default function SaleRoutePage() {
  const { pathname } = useLocation();
  const routeKey = useMemo(() => {
    const parts = pathname.split('/').filter(Boolean);
    return parts[parts.length - 1] || '';
  }, [pathname]);

  const config = getSalePageConfig(routeKey) || RECEPTIONIST_SALE_PAGES[0];
  if (config?.id === 'renewal-sale' || config?.route === 'renewal-sale') {
    return <RenewalSalePage key="renewal-sale" />;
  }
  return <AncillarySalePage key={config.id} config={config} />;
}
